module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ct",
    attrs: {
      "id": "d12e196"
    }
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "cpt",
    attrs: {
      "id": "d12e198"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Tada_9780310297864_epub_c2a_r1",
      "id": "d12e199"
    }
  }, [_vm._v("Title Page")])]), _vm._v(" "), _c('p', {
    staticClass: "cpt",
    attrs: {
      "id": "d12e201"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Tada_9780310297864_epub_c4_r1#d12e135",
      "id": "d12e202"
    }
  }, [_vm._v("Copyright Page")])]), _vm._v(" "), _c('p', {
    staticClass: "cpt",
    attrs: {
      "id": "d12e204"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Tada_9780310297864_epub_c6_r1#d12e254",
      "id": "d12e205"
    }
  }, [_vm._v("Before you begin. . .")])]), _vm._v(" "), _c('p', {
    staticClass: "cpt",
    attrs: {
      "id": "d12e207"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Tada_9780310297864_epub_c7_r1#d12e303",
      "id": "d12e208"
    }
  }, [_vm._v("January")])]), _vm._v(" "), _c('p', {
    staticClass: "cpt",
    attrs: {
      "id": "d12e210"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Tada_9780310297864_epub_c8_r1#d12e1363",
      "id": "d12e211"
    }
  }, [_vm._v("February")])]), _vm._v(" "), _c('p', {
    staticClass: "cpt",
    attrs: {
      "id": "d12e213"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Tada_9780310297864_epub_c9_r1#d12e2304",
      "id": "d12e214",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("March")])]), _vm._v(" "), _c('p', {
    staticClass: "cpt",
    attrs: {
      "id": "d12e216"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Tada_9780310297864_epub_c11_r1#d12e3302",
      "id": "d12e217",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("April")])]), _vm._v(" "), _c('p', {
    staticClass: "cpt",
    attrs: {
      "id": "d12e219"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Tada_9780310297864_epub_c12_r1#d12e4235",
      "id": "d12e220",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("May")])]), _vm._v(" "), _c('p', {
    staticClass: "cpt",
    attrs: {
      "id": "d12e222"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Tada_9780310297864_epub_c13_r1#d12e5210",
      "id": "d12e223",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("June")])]), _vm._v(" "), _c('p', {
    staticClass: "cpt",
    attrs: {
      "id": "d12e225"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Tada_9780310297864_epub_c14_r1#d12e6132",
      "id": "d12e226",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("July")])]), _vm._v(" "), _c('p', {
    staticClass: "cpt",
    attrs: {
      "id": "d12e229"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Tada_9780310297864_epub_c15_r1#d12e7115",
      "id": "d12e230",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("August")])]), _vm._v(" "), _c('p', {
    staticClass: "cpt",
    attrs: {
      "id": "d12e232"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Tada_9780310297864_epub_c16_r1#d12e8057",
      "id": "d12e233",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("September")])]), _vm._v(" "), _c('p', {
    staticClass: "cpt",
    attrs: {
      "id": "d12e235"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Tada_9780310297864_epub_c17_r1#d12e8979",
      "id": "d12e236",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("October")])]), _vm._v(" "), _c('p', {
    staticClass: "cpt",
    attrs: {
      "id": "d12e238"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Tada_9780310297864_epub_c18_r1#d12e9990",
      "id": "d12e239",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("November")])]), _vm._v(" "), _c('p', {
    staticClass: "cpt",
    attrs: {
      "id": "d12e241"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Tada_9780310297864_epub_c19_r1#d12e10936",
      "id": "d12e242",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("December")])]), _vm._v(" "), _c('p', {
    staticClass: "cpt",
    attrs: {
      "id": "d12e244"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Tada_9780310297864_epub_c19b_r1#d12e11891",
      "id": "d12e245",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "cpt",
    attrs: {
      "id": "d12e247"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Tada_9780310297864_epub_c19c_r1#d12e12249",
      "id": "d12e248",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Publisher")])]), _vm._v(" "), _c('p', {
    staticClass: "cpt",
    attrs: {
      "id": "d12e250"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Tada_9780310297864_epub_c19d_r1#d12e12258",
      "id": "d12e2261",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Share Your Thoughts")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a7287510","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tada_9780310297864_epub_c4a_r1.vue
// module id = 72
// module chunks = 0